import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getConfig } from '../config';
export var httpMethod;
(function (httpMethod) {
    httpMethod["GET"] = "GET";
    httpMethod["POST"] = "POST";
    httpMethod["PUT"] = "PUT";
    httpMethod["PATCH"] = "PATCH";
    httpMethod["DELETE"] = "DELETE";
})(httpMethod || (httpMethod = {}));
const validateParams = ({ method, queryParams, bodyParams }) => {
    if (queryParams) {
        if (method !== httpMethod.GET) {
            throw Error('Query params only with GET requests');
        }
    }
};
const getRequestUrl = ({ urlString, queryParams, }) => {
    const url = new URL(urlString);
    if (queryParams) {
        Object.keys(queryParams).forEach((key) => {
            const qParamValue = queryParams[key];
            if (Array.isArray(qParamValue)) {
                const queryParamValues = qParamValue;
                queryParamValues.forEach((param) => {
                    url.searchParams.append(key, param);
                });
            }
            else {
                url.searchParams.append(key, qParamValue);
            }
        });
    }
    return url;
};
/***
 * Hook for making authenticated and unauthenticated API calls.
 * For authenticated API calls, it uses Auth0 to get the access token.
 */
export const useApi = (apiProps, networkConfig) => {
    const { apiOrigin } = networkConfig || getConfig();
    const [state, setState] = useState({
        isLoading: false,
        data: null,
        error: null,
        message: '',
        statusCode: null,
    });
    const { getAccessTokenSilently } = useAuth0();
    /**
     * Function to perform the actual network request
     * It validates the params against the HttpMethod,
     * prepares and performs the requests.
     */
    const call = async (body) => {
        setState({
            ...state,
            statusCode: null,
            isLoading: true,
        });
        try {
            const bodyParams = { ...apiProps.body, ...body };
            const queryParams = { ...apiProps.queryParams, ...body };
            // validateParams({
            //   method: apiProps.httpMethod,
            //   queryParams: {},
            //   bodyParams: bodyParams,
            // });
            const urlString = `${apiOrigin}api/v${apiProps.version || 1}/${apiProps?.path}`;
            const url = getRequestUrl({ urlString, queryParams: apiProps.httpMethod === httpMethod.GET ? queryParams : {} });
            let headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
            };
            if (apiProps.authenticated) {
                const token = await getAccessTokenSilently();
                headers = {
                    ...headers,
                    Authorization: `Bearer ${token}`,
                };
            }
            const response = await fetch(url, {
                headers: headers,
                method: apiProps.httpMethod,
                body: apiProps.httpMethod !== httpMethod.GET ? JSON.stringify(bodyParams) : null,
            });
            let responseData = null;
            if (response.status < 300) {
                responseData = await response.json();
            }
            setState({
                ...state,
                data: responseData,
                statusCode: response.status || 413,
                isLoading: false,
            });
        }
        catch (error) {
            console.error({ error });
            setState({
                ...state,
                isLoading: false,
                statusCode: 500,
                error: error.error,
            });
        }
    };
    return { ...state, call };
};
